






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class LetterIcon extends Vue {
    @Prop({ required: true }) readonly letter!: string
    @Prop({ default: 'blue' }) readonly color!: string
    @Prop({ default: 10 }) readonly size!: number

    get formattedLetter(): string {
        return this.letter.length === 0 ? '' : this.letter.substr(0, 1).toUpperCase()
    }

    get componentClass(): string[] {
        return [
            `w-${this.size}`,
            `h-${this.size}`,
            `bg-${this.color}-100`,
            `text-${this.color}-300`,
        ]
    }
}
